import React, { useState } from 'react';
import { Button, Box, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { paths } from 'routes';
import { PaperCard } from 'components/Card';
import { RedMessageBar } from 'components/RedMessageBar';
import { useAuth } from 'lib/auth';
import { AuthLayout } from './AuthLayout';
import { JOIN_MODE_REQUEST } from './JoinCompany';
import { acceptPendingInvitation } from '../api/acceptInvitation';

export const MembershipPending = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { account, logout, refreshSession } = useAuth();
  const [error, setError] = useState('');
  const [acceptingID, setAcceptingID] = useState(null);

  const acceptInvitation = async (userID) => {
    setError('');
    setAcceptingID(userID);
    try {
      await acceptPendingInvitation(userID);
      await refreshSession(userID);
    } catch (error) {
      setError(error.message);
      setAcceptingID(null);
    }
  };

  const memberships = account?.users ?? [];

  return (
    <AuthLayout title={t('website:auth.membershipPending.pageTitle')}>
      <Box display="flex" justifyContent="center" alignItems="center" height={1} px={{ xs: 5, sm: 1 }}>
        <PaperCard px={{ xs: 2, sm: 4 }} width={{ xs: 1, sm: 369 }} maxWidth={369} bgcolor="#fff" sx={{ my: 5 }}>
          <Stack spacing={2}>
            <Typography variant="h5" sx={{ textAlign: 'center' }}>
              {t('website:auth.membershipPending.heading')}
            </Typography>
            <Typography variant="body1" sx={{ textAlign: 'center' }}>
              {t('website:auth.membershipPending.body')}
            </Typography>
            {error && <RedMessageBar message={error} />}
            {memberships.map((membership) => {
              const company = membership?.Company?.Name;
              return (
                <Stack key={membership.user_id} spacing={1}>
                  {membership.status === 'invited' && (
                    <>
                      <Typography variant="body1">{t('website:auth.membershipPending.invitation', { company })}</Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={acceptingID !== null}
                        onClick={() => acceptInvitation(membership.user_id)}
                      >
                        {t('website:auth.membershipPending.acceptButton')}
                      </Button>
                    </>
                  )}
                  {membership.status === 'access_requested' && (
                    <Typography variant="body1">{t('website:auth.membershipPending.accessRequested', { company })}</Typography>
                  )}
                  {membership.status !== 'invited' && membership.status !== 'access_requested' && (
                    <Typography variant="body1">{t('website:auth.membershipPending.inactive', { company })}</Typography>
                  )}
                </Stack>
              );
            })}
            <Button size="large" variant="contained" color="primary" onClick={() => navigate(paths.joinCompany)}>
              {t('website:auth.membershipPending.registerButton')}
            </Button>
            <Button size="large" variant="outlined" color="primary" onClick={() => navigate(paths.joinCompany, { state: { mode: JOIN_MODE_REQUEST } })}>
              {t('website:auth.membershipPending.requestAccessButton')}
            </Button>
            <Button size="large" variant="outlined" color="primary" onClick={logout}>
              {t('website:auth.membershipPending.logoutButton')}
            </Button>
          </Stack>
        </PaperCard>
      </Box>
    </AuthLayout>
  );
};
